import { combineReducers } from 'redux';
import { simpleReducer } from '@mgc/map-client-shared/lib/ReduxTools';

export default combineReducers({
    selectedTransaction: simpleReducer(null, {
        SELECT_TRANSACTION: (a) => a.payload.transaction,
        CANCELED_ORDER: null,
        EXCEL_CANCELED_ORDER: null,
    }),

    cancelProgress: simpleReducer('unknown', {
        CANCELING_ORDER: 'inprogress',
        CANCELING_EXCEL_ORDER: 'inprogress',
        CANCELED_ORDER: 'complete',
        CANCELED_EXCEL_ORDER: 'complete',
    }),

    progress: simpleReducer('unknown', {
        ORDER_COMPLETE: 'complete',
        EXCEL_ORDER_COMPLETE: 'complete',
        ORDER_FAILURE: 'error',
        EXCEL_ORDER_FAILURE: 'error',
        ORDER_INPROGRESS: 'inprogress',
        EXCEL_ORDER_INPROGRESS: 'inprogress',
        ORDER_PROGRESS_RESET: 'unknown',
        EXCEL_ORDER_PROGRESS_RESET: 'unknown',
    }),

    lastTransaction: simpleReducer(null, {
        ORDER_COMPLETE: (a) => a.payload.transaction,
        EXCEL_ORDER_COMPLETE: (a) => a.payload.transaction,
    }),
});



// WEBPACK FOOTER //
// ./app/reducers/order.js